import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, BreadcrumbModule],
})
export class BreadcrumbComponent {
  @Input() styleClass: string;

  @Input() items: MenuItem[];

  @Input() home: MenuItem;
}
